__turbopack_context__.v({
  "blink": "_YCj3a_blink",
  "root": "_YCj3a_root",
});
